module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment01_sp-80e4385c27cdd29209104fcd5274d26f.png";